import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Slide,
    Typography,
} from "@mui/material";
import { Container } from "@mui/system";
import React, { useState } from "react";
// import AppearanceReleasePageMeta from "../../META/AppearanceReleaseMeta";

const response_div = [
    " For good and valuable consideration, the receipt of which is hereby acknowledged, I hereby irrevocably grant to WooGlobe Ltd and its subsidiaries, parents, designees, licensees, successors and assigns (collectively, the “Company”), the absolute and unrestricted right and permission to record, copy, reproduce, adapt, modify, summarize, copyright, photograph, film, license, vend, rent, distribute, televise, publish, exhibit, disseminate, display, perform and otherwise exploit in any and all markets and media (collectively “use”) my appearance, name, likeness, voice, documents, biographical data, and other media artifacts provided to the Company by me or concerning me (collectively the “Materials”). This grant of rights is made without limitation upon time, circumstances, location, market, or medium of use, and includes without limitation all uses of the Materials in all types of content.",
    " I understand that all approvals or uses to which any of the Materials may be put will be determined by the producer working with the content/Materials, without limitation to any program, product, or service, and the related advertising and promotion thereof.",
    "Recognizing the Company’s reliance upon this Appearance Release, I hereby irrevocably release, discharge, and agree to indemnify and hold harmless the Company from and against all actions, damages, costs, liabilities, claims, losses, and expenses of every type and description, including without limitation any claim for violation, infringement, or invasion of any copyright, trademark right, privacy or publicity right, defamation, or any other right whatsoever that I now have or may ever have resulting from or relating to any such use of the Materials.",
    "I agree that the Company may copyright all audio and/or video recordings of the Materials, and that the Company and/or its licensees may copyright in its name and for its sole benefit any such audio or video recording containing the Materials.",
    "Nothing herein will constitute any obligation on the part of the Company to make any use of the rights or the Materials set forth above.",
    " I acknowledge that the terms and provisions of this Appearance Release are confidential in nature, and therefore agree that neither I nor my representatives will disclose the content or substance thereof to any third parties. Neither I nor my representatives shall issue any press releases or public statements about this Appearance Release or Company without Company’s prior written permission.",
    "This Appearance Release shall be governed by, and construed in accordance with, the laws of England & Wales and the parties submit to the exclusive jurisdiction of the courts of England & Wales, United Kingdom. I waive the right to revoke this Appearance Release, as well as any other right to injunctive or other equitable relief in connection with this Appearance Release.",
];

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="down" ref={ref} {...props} />;
});
export default function AppearanceRelease() {
    const [explaination, openExplanation] = useState(false);
    return (
        <Box
            display="flex"
            component={Container}
            flexDirection="column"
            gap={2.5}
        >
            {/* <AppearanceReleasePageMeta /> */}
            <Typography variant="h5" align="center" >
                <Box component="span" sx={{ color: "primary.main" }}> CreatorVault </Box> Appearance Release
            </Typography>
            <Box >
                <Button
                    color="primary"
                    onClick={() => openExplanation(true)}
                    variant="contained"
                >
                    What is an Appearance Release
                </Button>
            </Box>
            {response_div.map((text, i) => (
                <Box component={"ol"}>
                    <Typography variant="body1">
                        {text}
                    </Typography>
                </Box>
            ))}
            {/* Explaination */}
            <Dialog
                open={explaination}
                TransitionComponent={Transition}
                keepMounted
                onClose={() => {
                    openExplanation(false);
                }}
                aria-describedby="alert-dialog-slide-description"
            >
                <DialogTitle>
                    <Typography variant="h5" align="center" my={3}>
                        <Box component="span" sx={{ color: "primary.main" }}> CreatorVault </Box> Appearance Release
                    </Typography>
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-slide-description">
                        <Typography variant="body1">
                            {`An appearance release is a document required to secure the required
                            rights from video owner for use of the footage in commercial
                            settings. The commercial use of video opens up significantly higher
                            revenue earning opportunities for the video owners.`}
                        </Typography>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => openExplanation(false)}>Close</Button>
                </DialogActions>
            </Dialog>
        </Box>
    );
}
